import { MakeCall } from './createMakeCall';

import {
  RequestUserDocumentResponse,
  UserDocumentCategory,
} from './types/UserDocument';

const postUserDocumentRequest =
  (makeCall: MakeCall) =>
  (
    userId: 'me' | number,
    data: {
      category: UserDocumentCategory;
    },
  ) =>
    makeCall<RequestUserDocumentResponse>(
      'POST',
      `/api/v2/user/${userId}/document/request`,
      {
        data,
      },
    );
export { postUserDocumentRequest };
